const Contacts = [
  {
    id: 1,
    Team: "Tech Team",
    team: [
      {
        Designation: "Tech Advisor",
        data: [
          {
            url: "./TeamPhotos/IV Year/saket_mehta.png",
            Name: "Saket Mehta",
          },
        ],
      },
      {
        Designation: "Tech Head",
        data: [
          {
            url: "./TeamPhotos/III Year/ayush_sheel.jpg",
            Name: "Ayush Sheel",
          },
        ],
      },
      {
        Designation: "Tech Executive",
        data: [
          {
            url: "./TeamPhotos/II Year/seturaman_kumar.jpeg",
            Name: "Seturaman Kumar",
          },
          {
            url: "./TeamPhotos/II Year/aayushman_binodkumar_ranjan.jpg",
            Name: "Aayushman Ranjan",
          },
          {
            url: "./TeamPhotos/II Year/arush_moghe.jpeg",
            Name: "Arush Moghe",
          }
        ],
      },
    ],
  },

  {
    id: 6,
    Team: "Marketing Team",
    team: [
      {
        Designation: "Marketing Head",
        data: [
          {
            url: "./TeamPhotos/III Year/ayushi_vijayvargiya.jpg",
            Name: "Ayushi Vijay Vargiya",
          },
          {
            url: "./TeamPhotos/III Year/ipshita_joshi.png",
            Name: "Ipshita Joshi",
          },
        ],
      },
      {
        Designation: "Marketing Executive",
        data: [
          {
            url: "./TeamPhotos/II Year/dheeraj_borana.jpg",
            Name: "Dheeraj Borana",
          },
          {
            url: "./TeamPhotos/II Year/abhyudaya_singh.jpg",
            Name: "Abhyudaya Singh",
          },
          {
            url: "./TeamPhotos/II Year/isha_gupta.jpg",
            Name: "Isha Gupta",
          },
          {
            url: "./TeamPhotos/II Year/suhel_dev.jpg",
            Name: "Suhel Dev",
          },
        ],
      },
    ],
  },

  {
    id: 3,
    Team: "Branding Team",
    team: [
      {
        Designation: "Branding Head",
        data: [
          {
            url: "./TeamPhotos/III Year/devraj_mahawar.jpg",
            Name: "Devraj Mahawar",
          },
          {
            url: "./TeamPhotos/III Year/archi_arun.jpeg",
            Name: "Archi Arun",
          },
        ],
      },
    ],
  },

  {
    id: 4,
    Team: "Events Team",
    team: [
      {
        Designation: "Events Head",
        data: [
          {
            url: "./TeamPhotos/III Year/prakhar_srivastava.jpg",
            Name: "Prakhar Srivastava",
          },
          {
            url: "./TeamPhotos/III Year/yash_kumar_saha.jpg",
            Name: "Yash Kumar Saha",
          },
          {
            url: "./TeamPhotos/III Year/mahesh_pareta.jpg",
            Name: "Mahesh Pareta",
          },
          {
            url: "./TeamPhotos/III Year/kashish_kumari.jpg",
            Name: "Kashish Kumari",
          },
        ],
      },
    ],
  },

  {
    id: 2,
    Team: "Public Relations",
    team: [
      {
        Designation: "PR Head",
        data: [
          {
            url: "./TeamPhotos/III Year/photoMahika.jpg",
            Name: "Mahika Chaudhary",
          },
        ],
      },
      {
        Designation: "PR Executive",
        data: [
          {
            url: "./TeamPhotos/II Year/ekta_dubey.jpg",
            Name: "Ekta Dubey",
          },
        ],
      },
    ],
  },

  {
    id: 5,
    Team: "Publicity Team",
    team: [
      {
        Designation: "Publicity Head",
        data: [
          {
            url: "./TeamPhotos/III Year/aarti_meena.jpg",
            Name: "Aarti Meena",
          },
          {
            url: "./TeamPhotos/III Year/sarthak_chauhan.jpg",
            Name: "Sarthak Chauhan",
          },
          {
            url: "./TeamPhotos/III Year/aaditya_agrawal.jpg",
            Name: "Aaditya Agrawal",
          },
        ],
      },
    ],
  },
];

export default Contacts;
